import { render, staticRenderFns } from "./TopCustomersTable.vue?vue&type=template&id=613b5721"
import script from "./TopCustomersTable.vue?vue&type=script&lang=js"
export * from "./TopCustomersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports